import axios from '../axios-data'
import * as jsonHeaders from './serviceHeaders';


export const check = async (lastName, ssn, dateOfBirth) => {
  const headers = jsonHeaders.getHeaders();
  let data = {
    lastName,
    ssn,
    dateOfBirth,
  };
  try {
    return await axios
      .post(`/customer/check`, data, {
        headers,
      })
      .then((resp) => {
        return resp.data;
      });
  } catch (ex) {
    console.log(ex);
  }
  return null;
};

export const verify = async (
  firstName,
  lastName,
  suffix,
  streetAddress,
  apt,
  city,
  stateCode,
  zipCode,
  mobile,
  mobileType,
  branchId,
  accountNumber,
  token,
) => {
  const headers = jsonHeaders.getTokenizedHeaders(token);
  let data = {
    firstName,
    lastName,
    suffix,
    streetAddress,
    apt,
    city,
    state: stateCode,
    zipCode,
    phoneNumber: mobile,
    phoneType: mobileType,
    branchId,
    accountNumber,
    token,
  };
  try {
    return await axios.post(`/customer/verify`, data, { headers }).then((resp) => {
      return resp.data;
    });
  } catch (ex) {
    console.log(ex);
  }
  return null;
};

export const SendLiveCheckVerificationEmail = async (
  token,
  branchId,
  accountNumber,
  contractNumber,
  branchEmail,
  verified,
) => {
  const headers = jsonHeaders.getTokenizedHeaders(token);
  let data = {
    branchId,
    accountNumber,
    contractNumber,
    address: branchEmail,
    isVerified: verified,
  };
  if (verified !== null) {
    try {
      return await axios
        .post(`/customer/SendLiveCheckVerificationEmail`, data, { headers })
        .then((resp) => {
          return resp.data;
        });
    } catch (ex) {
      console.log(ex);
    }
  }
  return null;
};
